import axios from 'axios';

import store from '../store';
import { logoutRequest } from '../modules/login/services/LoginActions';
import { getCookie } from '../store/localStorage';
import { NOT_CONNECTED } from '../constants/routes';
import { getNavigate } from '../utils/history';
import { replaceHierarchyTermsWithAlias } from '../utils/commonUtils';

const MESSAGE_FIELDS = new Set(['resultMessage', 'errorMessage', 'message']);

const replaceHierarchyMessagesRecursively = (payload, userData) => {
    if (Array.isArray(payload)) {
        payload.forEach((item, index) => {
            payload[index] = replaceHierarchyMessagesRecursively(item, userData);
        });
        return payload;
    }

    if (!payload || typeof payload !== 'object') {
        return payload;
    }

    Object.keys(payload).forEach((key) => {
        const value = payload[key];

        if (MESSAGE_FIELDS.has(key) && typeof value === 'string') {
            payload[key] = replaceHierarchyTermsWithAlias(value, userData);
            return;
        }

        if (value && typeof value === 'object') {
            payload[key] = replaceHierarchyMessagesRecursively(value, userData);
        }
    });

    return payload;
};

const apiClient = axios.create({
    // baseURL: 'http://13.89.227.177:8654/api/', // Replace with your API base URL
    baseURL: window.configuration.API_BASE_URL, // Replace with your API base URL
    // baseURL : 'https://localhost:44371/api/'
});

// Request interceptor to add auth token and custom headers
apiClient.interceptors.request.use(
    (config) => {
        const authToken = getCookie('authToken');
        const userData = getCookie('userData');

        if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
        }
        if (userData?.UniqueKey) {
            config.headers['X-UniqueKey'] = userData.UniqueKey;
        }
        if (userData?._DK) {
            config.headers['_DK'] = userData._DK;
        }

        // Let axios handle Content-Type for FormData automatically
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle common errors
apiClient.interceptors.response.use(
    (response) => {
        const userData = getCookie('userData');
        if (response?.data && typeof response.data === 'object') {
            replaceHierarchyMessagesRecursively(response.data, userData);
        }
        return response;
    },
    (error) => {
        const userData = getCookie('userData');

        if (error?.response?.data && typeof error.response.data === 'object') {
            replaceHierarchyMessagesRecursively(error.response.data, userData);
        }

        if (error.response?.status === 401) {
            // Handle unauthorized access
            store.dispatch(logoutRequest());
        } else if (!error.response) {
            const navigate = getNavigate();
            navigate(NOT_CONNECTED, { replace: true });
        }
        return Promise.reject(error);
    }
);

const request = ({ ...options }) => {
    return apiClient(options)
        .then((response) => {
            if (response.status === 200) {
                return response.data;
            }
            throw new Error('Request failed');
        });
};

export const get = (url, params = {}) => request({ url, method: 'GET', params });

export const post = (url, data = {}) => request({ url, method: 'POST', data });

export const put = (url, data = {}) => request({ url, method: 'PUT', data });

export const del = (url, data = {}) => request({ url, method: 'POST', data });

// For Power BI

const apiClientPBI = axios.create({
    baseURL: '' // keep it empty
});

const requestPBI = ({ ...options }) => {
    return apiClientPBI(options)
        .then((response) => {
            if (response.status === 200) {
                return response.data;
            }
            throw new Error('Request failed');
        });
};

export const getPBI = ({ url, token = '', params = {}, headers = {} }) => requestPBI({
    url,
    method: 'GET',
    params,
    headers: {
        ...headers,
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    }
});

export const postPBI = ({ url, token = '', body = {}, headers = {} }) => requestPBI({
    url,
    method: 'POST',
    data: body,
    headers: {
        ...headers,
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    }
});
